import React from 'react';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: React.ReactNode;
  isMandatory?: boolean;
  placeholder?: string;
  type?: string;
  value?: string | number | readonly string[];
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  customClassName?: string;
}

const SmallInput: React.FC<Props> = ({
  label = '',
  error,
  placeholder,
  type,
  value,
  onChange,
  onFocus,
  customClassName,
  ...rest
}) => {
  return (
    <div className="input-wrapper__small-input">
      <input
        className={`input ${error ? 'input--error' : ''} ${customClassName ? customClassName : ''}`}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        {...rest}
      />
      <span className="name">{label}</span>
    </div>
  );
};

export default SmallInput;
